
import { defineComponent } from 'vue';
import Cronometer from './Cronometer.vue';
import AppButton from './AppButton.vue';

export default defineComponent({
  name: 'Timer',
  components: {
    Cronometer,
    AppButton
  },
  emits: ['timerFinished'],
  data() {
    return {
      timeInSeconds: 0,
      cronometerExecution: 0,
      isTimeRunning: false
    }
  },
  methods: {
    start() {
      this.isTimeRunning = true;
      this.cronometerExecution = setInterval(() => {
        this.timeInSeconds += 1;
      }, 1000);
    },

    stop() {
      this.isTimeRunning = false;
      clearInterval(this.cronometerExecution);
      this.$emit('timerFinished', this.timeInSeconds);
      this.timeInSeconds = 0;
    }
  }
});
